import SellerBenchMarkCard from './components/SellerOfferCard';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { getImage } from 'variables/images';
import WelcomeSellerModal from '../../main/seller/dashboard/components/WelcomeSellerModal';
import SignUpSellerModal from '../../main/seller/dashboard/components/SignUpSellerModal';
import KYCBanner from 'components/KYCBanner';

const SellerDashboard = () => {
    const [user, setUser] = useState(null);
    const [industries, setIndustries] = useState<any[]>([]);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                setUser(res.data);
                if (res.data && res.data.type !== 'seller') {
                    window.location.href = '/dashboard';
                } else if (res.data && res.data.email?.includes('guest-') && !res.data.isAlreadyConnected) {
                    setShowWelcomeModal(true);
                } else {
                    // Real logged-in user — clear any stale guest flag
                    localStorage.removeItem('guest-seller-signup');
                    setShowSignUpModal(false);
                }
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const initIndustries = () => {
        axios
            .get(`${CONFIG.apiUrl}/industry`)
            .then((res) => setIndustries(res.data))
            .catch(() => {});
    };

    useEffect(() => {
        if (
            !localStorage.getItem('token') ||
            localStorage.getItem('token').length < 10
        )
            window.location.href = '/auth/sign-up';
        initUser();
        initIndustries();
    }, []);

    // One card per catalog product with a price range set (back-office Industries page),
    // unless it's hidden from the seller marketplace (back-office "Marketplace vendeur").
    const subIndustryCards = industries.flatMap((ind) =>
        (ind.subIndustries ?? [])
            .filter((sub: any) => !sub.marketplace?.hidden && (sub.priceMin != null || sub.priceMax != null))
            .map((sub: any) => ({ industry: ind.name, subIndustry: sub.name, priceMin: sub.priceMin, priceMax: sub.priceMax }))
    );

    return (
        <div className="flex flex-col gap-6">
            <WelcomeSellerModal
                isOpen={showWelcomeModal}
                onClose={() => setShowWelcomeModal(false)}
                onSignUp={() => {
                    setShowWelcomeModal(false);
                    setShowSignUpModal(true);
                }}
            />
            <SignUpSellerModal
                isOpen={showSignUpModal}
                onClose={(success: boolean) => {
                    localStorage.removeItem('guest-seller-signup');
                    setShowSignUpModal(false);
                    if (success) window.location.reload();
                }}
            />

            {/* Header */}
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">
                    Marché
                </p>
                <h1 className="mt-1 font-crimson text-4xl font-semibold leading-tight text-leadrs-text">
                    Benchmark
                </h1>
                <p className="mt-2 font-geist text-sm text-leadrs-text-soft">
                    Consultez les prix de vente par industrie.
                </p>
            </div>

            <KYCBanner user={user} onUserRefresh={initUser} />

{/* Grid */}
            {subIndustryCards.length > 0 ? (
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                    {subIndustryCards.map(({ industry, subIndustry, priceMin, priceMax }) => (
                        <SellerBenchMarkCard
                            key={`${industry}|||${subIndustry}`}
                            title={subIndustry}
                            author={industry}
                            priceMin={priceMin}
                            priceMax={priceMax}
                            image={getImage(industry, subIndustry)}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex flex-col items-center gap-3 py-16">
                    <p className="font-geist text-sm font-medium text-leadrs-text">
                        Aucun prix disponible pour le moment
                    </p>
                    <p className="font-geist text-xs text-leadrs-text-soft">
                        Les tranches de prix définies par notre équipe apparaîtront ici.
                    </p>
                </div>
            )}
        </div>
    );
};

export default SellerDashboard;
